export default class SaveGameModel {
    constructor() {
        this.reset();
    }

    reset() {
        this._version = SaveGameModel.CURRENT_SAVE_GAME_VERSION;

        // Persisted fields.
        this._hasSeenIntroSequence = false;
        this._progressModelData = {};
        this._playerModelData = {};
        this._onboardingModelData = {};
        this._personalReportModelData = {};
        this._charactersData = {};

        // Non-persistent fields.
        this._gameSavedFeedbackPending = false;
    }

    versionIsSupported() {
        return this.version === SaveGameModel.CURRENT_SAVE_GAME_VERSION;
    }

    get version() {
        return this._version;
    }

    get gameSavedFeedbackPending() {
        return this._gameSavedFeedbackPending;
    }

    set gameSavedFeedbackPending(value) {
        this._gameSavedFeedbackPending = value;
    }

    get hasSeenIntroSequence() {
        return this._hasSeenIntroSequence;
    }

    set hasSeenIntroSequence(value) {
        this._hasSeenIntroSequence = value;
    }

    get progressModelData() {
        return this._progressModelData;
    }

    set progressModelData(value) {
        this._progressModelData = value;
    }

    get playerModelData() {
        return this._playerModelData;
    }

    set playerModelData(value) {
        this._playerModelData = value;
    }

    get onboardingModelData() {
        return this._onboardingModelData;
    }

    set onboardingModelData(value) {
        this._onboardingModelData = value;
    }

    get personalReportModelData() {
        return this._personalReportModelData;
    }

    set personalReportModelData(value) {
        this._personalReportModelData = value;
    }

    get charactersData() {
        return this._charactersData;
    }

    set charactersData(value) {
        this._charactersData = value;
    }

    toObject() {
        return {
            version: this._version,
            progressModelData: this.progressModelData,
            playerModelData: this.playerModelData,
            onboardingModelData: this.onboardingModelData,
            personalReportModelData: this.personalReportModelData,
            charactersData: this.charactersData,
            hasSeenIntroSequence: this.hasSeenIntroSequence,
        };
    }

    fromObject(obj) {
        this._version = obj.version;
        this._progressModelData = obj.progressModelData ?? {};
        this._playerModelData = obj.playerModelData ?? {};
        this._onboardingModelData = obj.onboardingModelData ?? {};
        this._personalReportModelData = obj.personalReportModelData ?? {};
        this._charactersData = obj.charactersData ?? {};
        this._hasSeenIntroSequence = obj.hasSeenIntroSequence ?? false;
    }

    serialize() {
        return new Promise((resolve, reject) => {
            try {
                resolve(JSON.stringify(this.toObject()));
            } catch (ex) {
                console.warn(`[SaveGameModel] Unable to serialize save game to JSON.`, ex);

                reject(ex);
            }
        });
    }

    deserialize(data) {
        return new Promise((resolve, reject) => {
            try {
                const obj = JSON.parse(data);
                this.fromObject(obj);

                resolve();
            } catch (ex) {
                console.warn(`[SaveGameModel] Unable to parse save game JSON.`, ex);

                reject(ex);
            }
        });
    }

    static CURRENT_SAVE_GAME_VERSION = 4; // Bump this number when the savegame format changes. This will clear all existing savegames.
}